import React from "react";
import { Switch, Route, Router } from "react-router-dom";
import history from "../../Assets/Lib/history";
import List from "./List";
import Add from "./Add";
import Edit from "./Edit";
import NavigationLayout from "../../Components/NavigationLayout";

const WellnessCenters = () => {
  return (
    <NavigationLayout>
      <Router history={history}>
        <Switch>
          <Route exact path="/admin/wellness-centers" component={List} />
          <Route path="/admin/wellness-centers/new" component={Add} />
          <Route path="/admin/wellness-centers/:id" component={Edit} />
        </Switch>
      </Router>
    </NavigationLayout>
  );
};
export default WellnessCenters;
